import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { NoteService } from "../../../../Component/Api/Note/NoteService";
import AppAccordion from "../../../../Component/Common/Components/Accordion/AppAccordion";
import { DataTable } from "../../../../Component/Common/Components/DataTable/DataTable";
import { Note } from "../../../../Component/Model/Dto/Note";
import { defaultObject } from "../../../../Component/Model/helpers";
import { EntriesPerPage } from "../../../../Component/Model/Table/Table";
import {  FeedbackModal } from "./FeedbackModal";
import { FeedbackTableMapper } from "./FeedbackTableColumn";

interface IProps {
    noteId: string;
    userId: string;
}

export const FeedbackTable = (props: IProps) => {
    const [previewPopup, setPreviewPopup] = React.useState<boolean>(false);
    const [feedbackData, setFeedbackData] = React.useState<Note.FeedbackSearchDtoIn[]>(defaultObject);
    const [entriesPerPage, setEntriesPerPage] = React.useState<EntriesPerPage>({ defaultValue: 10 });
    const [pageNumber, setPageNumber] = React.useState<number>(1);
    const [filteredItemsCount, setFilteredItemsCount] = React.useState<number>(0);
    const [totalItemsCount, setTotalItemsCount] = React.useState<number>(0);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [searchValue, setSearchValue] = React.useState<string>('');


    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage({ defaultValue: entriesPerPage });
        setPageNumber(1);
    }

    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    }
    const searchValueChanged = (value: string) => {
        setSearchValue(value);
    }

    const handleClosePopup = () => {
        setPreviewPopup(false);
    }

    const handleDelete = async (id: string) => {
        try {
            await NoteService.DeleteFeedback(id);
            toast.success("Feedback item deleted succesfully")
            fetchData();

        } catch (error) {
            console.log(error)
        }

    }

    const feedbackSearchRequest: Note.FeedbackSearchRequest = {
        Draw: 2,
        NoteId: props.noteId,
        PageNumber: pageNumber,
        PageSize: entriesPerPage.defaultValue as number,
        SearchValue: searchValue,
        SortColumnNames: [],
        SortDirections: []
    };

    const fetchData = async () => {
        setIsLoading(true);
        try {
            let searchResult = await NoteService.SearchFeedback(feedbackSearchRequest);
            if (searchResult.data) {
                setFeedbackData(searchResult.data.dataObject);
                setFilteredItemsCount(searchResult.data.filteredItemsCount);
                setTotalItemsCount(searchResult.data.totalItemsCount);

            }
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false);
        }

    };

    useEffect(() => {
        fetchData();
    }, [entriesPerPage, pageNumber, searchValue]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleAddFeedback = () => {
        setPreviewPopup(true)
    }
    const bulkActions = [
        {
            label: "Add Feedback Item",
            action: handleAddFeedback
        }
    ]


    const feedbackTableData = FeedbackTableMapper(feedbackData, handleDelete);

    return (
        <>
            <AppAccordion expandOnDefault={false} label='Feedback'>
                {feedbackTableData !== undefined &&
                    <DataTable
                        table={feedbackTableData}
                        entriesPerPage={entriesPerPage}
                        pageNumber={pageNumber}
                        filteredItemsCount={filteredItemsCount}
                        totalItemsCount={totalItemsCount}
                        entriesPerPageChanged={entriesPerPageChanged}
                        pageNumberChanged={pageNumberChanged}
                        isLoading={isLoading}
                        canSearch={true}
                        searchValueChanged={searchValueChanged}
                        bulkActions={bulkActions}
                    ></DataTable>
                }
            </AppAccordion>
            {previewPopup && <FeedbackModal noteId={props.noteId} userId={props.userId} showFeedbackModal={previewPopup} closeFeedbackModal={handleClosePopup} refreshTable={fetchData} />}
 
        </>
    )
}
